'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    position: relative;\n\n    input {\n        padding-left: 24px;\n    }\n\n    svg {\n        position: absolute;\n        top: 10px;\n        left: 8px;\n        z-index: 1;\n        color: #6f869f;\n    }\n'], ['\n    position: relative;\n\n    input {\n        padding-left: 24px;\n    }\n\n    svg {\n        position: absolute;\n        top: 10px;\n        left: 8px;\n        z-index: 1;\n        color: #6f869f;\n    }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _fa = require('react-icons/fa');

var _rifm = require('rifm');

var _StyledInput = require('./StyledInput');

var _withFieldWrapper = require('../hocs/withFieldWrapper');

var _withFieldWrapper2 = _interopRequireDefault(_withFieldWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var WithPhone = _styledComponents2.default.div(_templateObject);

var numberFormat = function numberFormat(str) {
    var r = parseInt(str.replace(/[^\d]+/gi, ''), 10);
    return r ? '+' + r : '';
};

var NumberInput = function (_Component) {
    _inherits(NumberInput, _Component);

    function NumberInput() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, NumberInput);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NumberInput.__proto__ || Object.getPrototypeOf(NumberInput)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (value) {
            return _this.props.onChange(value);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(NumberInput, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                inputValue = _props.value,
                disabled = _props.disabled,
                label = _props.label;


            var inputComponent = _react2.default.createElement(
                _rifm.Rifm,
                {
                    value: inputValue || '',
                    onChange: this.onChange,
                    format: numberFormat
                },
                function (_ref2) {
                    var value = _ref2.value,
                        onChange = _ref2.onChange;
                    return _react2.default.createElement(_StyledInput.StyledInput, {
                        value: value,
                        onChange: onChange,
                        disabled: disabled,
                        placeholder: label
                    });
                }
            );

            return _react2.default.createElement(
                WithPhone,
                null,
                _react2.default.createElement(_fa.FaPhoneAlt, null),
                inputComponent
            );
        }
    }]);

    return NumberInput;
}(_react.Component);

NumberInput.propTypes = {
    value: _propTypes2.default.string,
    input: _propTypes2.default.object,
    label: _propTypes2.default.string,
    onChange: _propTypes2.default.func,
    disabled: _propTypes2.default.bool
};
exports.default = (0, _withFieldWrapper2.default)(NumberInput);